module.exports = __webpack_public_path__ + "static/media/meeting_room.666350f9.png";